var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodVial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19V6H16V19M8 19C8 21.2091 9.79086 23 12 23C14.2091 23 16 21.2091 16 19M8 19H16M9 4L9 6M11.9999 4L11.9999 6M8 10H16M15 4L15 6M7 6H17C17.5523 6 18 5.55228 18 5V2C18 1.44772 17.5523 1 17 1H7C6.44772 1 6 1.44772 6 2V5C6 5.55228 6.44772 6 7 6ZM11.8795 12.5668L10.73 14.4059C10.5957 14.6209 10.5236 14.8495 10.5049 15.0761C10.4369 15.9009 11.0772 16.6973 12 16.6973C13.1763 16.6973 13.8934 15.4034 13.27 14.4059L12.1205 12.5668C12.0927 12.5223 12.0463 12.5 12 12.5C11.9537 12.5 11.9073 12.5223 11.8795 12.5668Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodVial);
export default __webpack_public_path__ + "static/media/blood-vial.b074dbed35741731ed8526fd17f0c244.svg";
export { ForwardRef as ReactComponent };